import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Box } from '@mui/material';
import { FragmentCardDurationPill } from '../base/FragmentCardDurationPill';
import { FragmentCardListBase } from '../base/FragmentCardListBase';
import { FragmentCardMediaBottomRightItem } from '../base/FragmentCardMediaBottomRightItem';
import { PosterVariant } from '../hooks/useFragmentPosterPolling';
import { FragmentCardPosterWithPolling } from './FragmentCardPosterWithPolling';

/**
 * List layout for a video fragment card: poster (with duration pill on media),
 * title, time/duration, creator and created at, statuses. Used when viewMode is 'list'.
 */
export function VideoFragmentCardList({
  fragment,
  posterSrc,
  variant,
}: {
  fragment: FragmentListItemDto;
  posterSrc: string | null;
  variant: PosterVariant | null;
}) {
  return (
    <FragmentCardListBase
      fragment={fragment}
      media={
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            aspectRatio: '16/9',
          }}
        >
          <FragmentCardPosterWithPolling
            fragmentId={fragment.id}
            posterSrc={posterSrc}
            variant={variant}
          />
          {/* <VideoFragmentVariantChip variant={variant} /> */}
          <FragmentCardMediaBottomRightItem>
            <FragmentCardDurationPill fragment={fragment} />
          </FragmentCardMediaBottomRightItem>
        </Box>
      }
    />
  );
}
